﻿import * as Res from "./res";
import { createElement, uniqueId } from "./_dom";
import { initPopupContainer, closePopup } from "./_menu";
import { postbackCell } from "./_fs";

function createItems(formId, items) {
	return items.map(item =>
		createElement("li", { role: "none", class: "v3-tableview-customize__menu-cell v3-menu__cell" },
			createElement("label", { role: "menuitemcheckbox", class: "v3-tableview-customize__menu-item v3-menu__item" },
				createElement("input", { type: "checkbox", name: "showhidecolumn", class: "v3-input-checkbox", checked: item.show, value: item.id, form: formId }),
				`\xA0${item.title}`)));
}

function createDropdownMenu(button, { columns }) {
	const formId = button.form.id;

	let dropdown = null;

	function handlePostbackCell({ currentTarget: button }) {
		var checked = [];
		if (button.value === "update") {
			checked = [...dropdown.querySelectorAll('input[name="showhidecolumn"][type=checkbox]:checked')].map(checkbox => checkbox.value);
		}
		postbackCell(button.form, button, "showhidecolumn", checked.join(","));
	}

	dropdown = createElement("div", { id: uniqueId("v3-tableview-customize__popup"), class: "v3-tableview-customize-popup v3-popup", "data-popup-autoheight": "" },
		createElement("ul", { role: "menu", class: "v3-tableview-customize__menu v3-menu v3-menu-scrollable" },
			...createItems(formId, columns.filter(c => c.show)),
			...createItems(formId, columns.filter(c => !c.show))
		),
		createElement("center", { class: "v3-tableview-customize__buttonbar" },
			createElement("button", { type: "button", class: "v3-tableview-customize__button v3-button", value: "update", form: formId, onclick: handlePostbackCell }, Res.getString("view.customize.update")),
			createElement("button", { type: "button", class: "v3-tableview-customize__button v3-button", value: "reset", form: formId, onclick: handlePostbackCell }, Res.getString("view.customize.reset"))
		)
	);
	button.setAttribute("aria-controls", dropdown.id);

	const container = initPopupContainer();
	container.append(dropdown);
}

function destroyDropdownMenu(button/*, options*/) {
	const dropdownId = button.getAttribute("aria-controls");
	const dropdown = dropdownId && document.getElementById(dropdownId);
	if (dropdown && !dropdown.matches(":focus-within")) {
		closePopup(dropdown);
	}
}

function toggleDropdownMenu(button, options) {
	if (button.getAttribute("aria-expanded") === "true") {
		destroyDropdownMenu(button, options);
	} else if (!document.getElementById(button.getAttribute("aria-controls"))) {
		createDropdownMenu(button, options);
	}
}

function attachMenuHandlers(button, options) {
	button.addEventListener("click", ({ currentTarget: target }) => toggleDropdownMenu(target, options));
	button.addEventListener("v3-popup.close", ({ detail: dropdown }) => {
		dropdown.remove();
		dropdown.popperInstance?.destroy();
	});
}

function doInitCustomize(table) {
	const options = JSON.parse(table.dataset.customize);
	const button = table.parentElement.querySelector(".v3-tableview-customize__dropdown");
	if (button) {
		button.classList.add("js-auto-popup", "v3-popup-trigger");
		button.setAttribute("aria-haspopup", "true");
		if (!button.getAttribute("data-popper-placement"))
			button.setAttribute("data-popper-placement", "bottom-end");
		attachMenuHandlers(button, options);
	}
}

function init(context, selector = ".v3-tableview[data-customize]") {
	(context || document).querySelectorAll(selector).forEach(doInitCustomize);
}

export { init };